import { fetchImagesDimensions, type IImageDimensionsData } from "@/shared";
import type { IMediaFile } from "@/shared/types";

export const fetchAndSortMediaFilesImagesByResolution = async (
  files: IMediaFile[],
) => {
  const rest: IMediaFile[] = [];
  const fetchPromises: Promise<IImageDimensionsData>[] = [];
  for (const file of files) {
    if (file.typeGroup === "image") {
      fetchPromises.push(fetchImagesDimensions(file.url, file._id));
    } else {
      rest.push(file);
    }
  }

  const results = await Promise.allSettled(fetchPromises);
  const successfulResults = results
    .filter(
      (r): r is PromiseFulfilledResult<IImageDimensionsData> =>
        r.status === "fulfilled",
    )
    .map((r) => r.value)
    .sort((a, b) => b.resolution - a.resolution);

  const sortedFiles: IMediaFile[] = successfulResults
    .map((item) => files.find((file) => file._id === item.id))
    .filter((file): file is IMediaFile => Boolean(file));

  return [...rest, ...sortedFiles];
};
